import {PageLayout} from "base/layout";
import {ModuleConfigProvider} from "base/provider";

export const SocioeconomicModule = () => {
    return (
        <ModuleConfigProvider name="Indicators" path="indicators">
            <PageLayout className="indicators" disablePadding={true} />
        </ModuleConfigProvider>
    );
};
